import { ReactElement } from 'react';
import { Card, Descriptions } from 'antd';
import dayjs from 'dayjs';
import formatTime from '../../utils/formatTime';

interface Props {
  duration: number | null;
  registeredAt: Date;
}

const RecordingData = ({ duration, registeredAt }: Props): ReactElement => {
  const formattedDuration = duration !== null ? formatTime(duration) : '不明';
  const formattedRegisteredAt = dayjs(registeredAt).format('YYYY年M月D日 HH:mm');

  return (
    <Card size='small'>
      <Descriptions column={1} size='small' layout='vertical'>
        <Descriptions.Item label='録音時間'>{formattedDuration}</Descriptions.Item>
        <Descriptions.Item label='登録日時'>{formattedRegisteredAt}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default RecordingData;
